import { useTranslator, useAppContext } from '@front-activerse/common-components';

const TokenExpiredError = () => {
  const { t } = useTranslator();

  const {
    images: { removeAccountAlert },
  } = useAppContext();

  return (
    <div className="white-box text-center">
      <img src={removeAccountAlert} className="mb-l" alt="" />
      <p className="semi-bold mb-l">{t('deletingAccount.notification.linkExpired.title')}</p>
      <p className="mb-0">{t('deletingAccount.notification.linkExpired.content')}</p>
    </div>
  );
};

export default TokenExpiredError;
